<template>
  <div class="main-content" id="panel">
    <div class="header bg-primary pb-6">
      <div class="container-fluid">
        <div class="header-body">
          <div class="row align-items-center py-4">
            <div class="col-lg-2 col-md-12 mb-4">
              <h2>Report</h2>
            </div>
            <div class="col-lg-10 col-md-12 col-10 text-right bid d-flex" style="justify-content: end;">
              <div class="text-white mt-2 mr-2">Total Records : {{totalRows}}</div>
              <button @click="exportData()" type="button" class="btn btn-danger rounded" ><i class="fa fa-download"></i> EXPORT</button>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="container-fluid mt--6 filter-show">
        <div class="card w-100 p-2 mb-2 d-inline-block">
          <div class="d-flex justify-content-between">
            <h5 class="ml-3">Filters</h5>
            <span class="btn btn-link" @click="showFilters = !showFilters">
              <i
                class="fa"
                v-bind:class="[showFilters ? 'fa-angle-up' : 'fa-angle-down']"
              ></i>
              {{ showFilters ? "Hide" : "Show" }} Filters
            </span>
          </div>
          <div class="row" v-if="showFilters">
            <div class="col-lg-12">
              <form class="row">
                <div class="col-md-6 col-lg-3">
                  <label for="filter">FROM</label>
                  <datepicker
                    v-model="fromDate"
                    name="fromDate"
                    format="MM/dd/yyyy"
                    :clear-button="true"
                    :calendar-button="true"
                    calendar-button-icon="fas fa-calendar-alt datepicker_icon"
                  ></datepicker>
                </div>
                <div class="col-md-6 col-lg-3">
                  <label for="filter">TO</label>
                  <datepicker
                    v-model="toDate"
                    name="toDate"
                    format="MM/dd/yyyy"
                    :clear-button="true"
                    :calendar-button="true"
                    calendar-button-icon="fas fa-calendar-alt datepicker_icon"
                  ></datepicker>
                </div>
                <div class="col-md-6 col-lg-3">
                  <label>CUSIP</label>
                  <input
                    style="height: 42px"
                    class="form-control"
                    v-model="searchValue"
                  />
                </div>
                <div class="col-md-6 col-lg-3">
                  <label>STATUS</label>
                  <multiselect
                    v-model="status"
                    placeholder="Select status"
                    :options="statusList"
                    :multiple="true"
                    :limit="3"
                  ></multiselect>
                </div>
                <div class="col-md-6 col-lg-3">
                  <label>ECN</label>
                  <multiselect
                    v-model="ecn"
                    placeholder="Select ecn"
                    :options="['IBP', 'TWD', 'TMC']"
                    :multiple="true"
                    :limit="3"
                  ></multiselect>
                </div>
                <div class="col-md-6 col-lg-3">
                  <label>TRADER</label>
                  <multiselect
                    v-model="filterTrader"
                    placeholder="Select traders"
                    label="firstName"
                    track-by="id"
                    :options="traderList"
                    :multiple="false"
                    :limit="3"
                  ></multiselect>
                </div>
                <div class="col-md-4 col-lg-2">
                    <div class="form-check mt-4">
                      <input id="checkbox2" type="checkbox"  class="form-check-input wh" v-model="showFailedLogs" >
                      <label for="checkbox2" class="form-check-label mt-1">SHOW FAILED LOGS</label>
                    </div>
                </div>
                  
                <!-- <div class="col-md-4 col-lg-3">
                  <div class="form-check mt-4">
                    <input
                      id="checkbox2"
                      type="checkbox"
                      class="form-check-input wh"
                      v-model="isShowExpired"
                    />
                    <label for="checkbox2" class="form-check-label"
                      >Show Expired
                    </label>
                  </div>
                </div> -->
                <div class="col-md-6 col-lg-3">
                  <button
                    @click="clear()"
                    type="button"
                    class="btn btn-secondary rounded mt-4"
                  >
                    Clear
                  </button>
                  <button
                    @click="search()"
                    type="button"
                    class="btn btn-primary rounded mt-4"
                  >
                    Filter
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid">
        <div class="row xsOnly">
          <div class="col-xl-12">
            <div class="card vh-75" id="scroll">
              <div class="table-responsive">
                <div v-if="loading" class="loader">
                  <img src="@/assets/img/loader.svg" alt="" />
                </div>
                <table
                  class="table align-items-center table-flush table-hover bidtbl"
                  style="min-height: 125px"
                >
                  <thead class="thead-light psticky">
                    <tr>
                      <th
                        scope="col"
                        class="sort text-center"
                        v-bind:class="[
                          sortOrder == 'ASC' && sortColumn == 'cusip'
                            ? 'sort-asc'
                            : '',
                          sortOrder == 'DESC' && sortColumn == 'cusip'
                            ? 'sort-desc'
                            : '',
                        ]"
                        @click="sort('cusip')"
                      >
                        Cusip
                      </th>
                      <th
                        scope="col"
                        class="sort text-center"
                        v-bind:class="[
                          sortOrder == 'ASC' && sortColumn == 'orderQty'
                            ? 'sort-asc'
                            : '',
                          sortOrder == 'DESC' && sortColumn == 'orderQty'
                            ? 'sort-desc'
                            : '',
                        ]"
                        @click="sort('orderQty')"
                      >
                        QTY
                      </th>
                      <th
                        scope="col"
                        class="sort text-center"
                        v-bind:class="[
                          sortOrder == 'ASC' && sortColumn == 'ecn'
                            ? 'sort-asc'
                            : '',
                          sortOrder == 'DESC' && sortColumn == 'ecn'
                            ? 'sort-desc'
                            : '',
                        ]"
                        @click="sort('ecn')"
                      >
                        ECN
                      </th>
                      <th
                        scope="col"
                        class="sort text-center"
                        v-bind:class="[
                          sortOrder == 'ASC' && sortColumn == 'status'
                            ? 'sort-asc'
                            : '',
                          sortOrder == 'DESC' && sortColumn == 'status'
                            ? 'sort-desc'
                            : '',
                        ]"
                        @click="sort('status')"
                      >
                        STATUS
                      </th>
                      <th
                        scope="col"
                        class="sort text-center"
                        v-bind:class="[
                          sortOrder == 'ASC' && sortColumn == 'settleDate'
                            ? 'sort-asc'
                            : '',
                          sortOrder == 'DESC' && sortColumn == 'settleDate'
                            ? 'sort-desc'
                            : '',
                        ]"
                        @click="sort('settleDate')"
                      >
                        SETTLEMENT DATE
                      </th>
                      <th
                        scope="col"
                        class="sort text-center"
                        v-bind:class="[
                          sortOrder == 'ASC' && sortColumn == 'traderFirstName'
                            ? 'sort-asc'
                            : '',
                          sortOrder == 'DESC' && sortColumn == 'traderFirstName'
                            ? 'sort-desc'
                            : '',
                        ]"
                        @click="sort('traderFirstName')"
                      >
                        TRADER
                      </th>
                      <th 
                      scope="col" 
                      class="sort text-left"
                      >ASSIGNED TO <br>
                      <span>Suggested Price - yield</span></th>
                      <th 
                      scope="col" 
                      class="sort text-left"
                      >BID PRICE -yield</th>
                      <th
                        scope="col"
                        class="sort text-center"
                        v-bind:class="[
                          sortOrder == 'ASC' && sortColumn == 'bondInsurer'
                            ? 'sort-asc'
                            : '',
                          sortOrder == 'DESC' && sortColumn == 'bondInsurer'
                            ? 'sort-desc'
                            : '',
                        ]"
                        @click="sort('bondInsurer')"
                      >
                        BOND INSURER
                      </th>
                      <th 
                      scope="col" 
                      class="sort text-center"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'callDate'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'callDate'  ? 'sort-desc' : '']"  
                      @click="sort('callDate')">call Date</th> 
                      <th 
                      scope="col" 
                      class="sort text-center"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'maturityDate'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'maturityDate'  ? 'sort-desc' : '']"  
                      @click="sort('maturityDate')">maturity Date</th> 
                      <th
                        scope="col"
                        class="sort text-center"
                        v-bind:class="[
                          sortOrder == 'ASC' && sortColumn == 'cusipCoupon'
                            ? 'sort-asc'
                            : '',
                          sortOrder == 'DESC' && sortColumn == 'cusipCoupon'
                            ? 'sort-desc'
                            : '',
                        ]"
                        @click="sort('cusipCoupon')"
                      >
                        COUPON
                      </th>
                      <th
                        scope="col"
                        class="sort text-center"
                        v-bind:class="[
                          sortOrder == 'ASC' && sortColumn == 'stateName'
                            ? 'sort-asc'
                            : '',
                          sortOrder == 'DESC' && sortColumn == 'stateName'
                            ? 'sort-desc'
                            : '',
                        ]"
                        @click="sort('stateName')"
                      >
                        STATE
                      </th>
                      <th scope="col" class="sort text-left">
                        Collection Details
                      </th>
                     
                    </tr>
                  </thead>
                  <tbody class="list no-cursor">
                    <tr v-if="bidwantedList.length == 0 && !loading">
                      <td><p class="nodata">No data available</p></td>
                    </tr>
                    <tr v-for="(data,index) in bidwantedList" :key="index">
                      <td class="text-center">
                        <span
                          class="cusips"
                          @click="toggleSupportDataModal(data)"
                          >{{ data.cusip }}</span
                        >
                      </td>
                      <td class="text-center">{{ data.orderQty }}</td>
                      <td class="text-center">
                        {{ data.ecn }}
                      </td>
                      <td class="text-center">
                        {{ data.status }}
                      </td>
                      <td class="text-center">
                        {{
                          data.settleDate
                            ? moment(data.settleDate).format("MM/DD/YYYY")
                            : "N/A"
                        }}
                      </td>
                      <td class="text-center">
                        {{ data.traderFirstName }}
                      </td>
                      <td class="text-left">
                        <div>
                          <div style="margin-bottom: 3px;" v-for="trader in data.traderList" :key="trader.traderId">
                            <span class="text-dark">{{ trader.firstName }} {{ trader.lastName }}</span>
                            <div>
                              <span v-if="!trader.idcFailureReason" class="text-success">{{ trader.suggestedPrice | currency }} </span> - <span class="text-info">{{ trader.calculatedYield ? trader.calculatedYield.toFixed(3) : "" }}</span>
                              <span v-if="trader.idcFailureReason" class="text-warning">{{ trader.idcFailureReason }} </span>
                            
                            </div>
                          </div>
                          <div class="ml-8" v-if="data.isSuggestPriceFailed">
                            <a  data-toggle="tooltip" data-placement="left" title="Failed Log History" @click="toggleFailedLogModal(data)" class="btn ibtn btn-outline-danger"><i class="fas fa-history"></i></a>
                          </div>
                        </div>
                        <!-- <div v-for="trader in data.traderList" :key="trader.traderId">
                            {{ trader.firstName }} {{ trader.lastName }} - <span class="text-success">{{ trader.suggestedPrice | currency }}</span> - <span class="text-primary">{{ trader.calculatedYield ? trader.calculatedYield.toFixed(3) : "" }}</span>
                          </div> -->
                      </td>
                      <td class="text-center">
                        {{ data.bidPrice  | currency }} - {{ data.bidPriceYield }}
                      </td>
                      <td class="text-center">
                        {{ getAbbreviation(data.bondInsurer) }}
                      </td>
                      <td class="text-center">
                      {{ data.callDate ? moment(data.callDate).format("MM/DD/YYYY") : "N/A" }}
                    </td>
                    <td class="text-center">
                      {{ data.maturityDate ? moment(data.maturityDate).format("MM/DD/YYYY") : "N/A" }}
                    </td>
                      <td class="text-center">
                        {{ data.cusipCoupon | percent(3) }}
                      </td>
                      <td class="text-center">
                        {{ data.stateName }}
                      </td>
                      <td class="text-left">
                        <span v-if="data.ecn == 'IBP'"
                          ><span class="maturity">Collecting Until</span> :
                          <span class="">{{
                            data.bidBy
                              ? moment
                                  .utc(data.bidBy)
                                  .tz('America/New_York')
                                  .format("hh:mm:ss a")
                              : "N/A"
                          }} EST</span></span
                        >
                        <span v-if="data.ecn == 'TMC'">
                          <div>
                            <span class="maturity">Collecting Until</span> :
                            <span class="">{{
                              data.bidBy
                                ? moment
                                    .utc(data.bidBy)
                                    .tz('America/New_York')
                                    .format("hh:mm:ss a")
                                : "N/A"
                            }} EST</span>
                          </div>
                          <div>
                            <span class="maturity">Firm Until</span> :
                            <span class="">{{
                              data.firmUntill
                                ? moment
                                    .utc(data.firmUntill)
                                    .tz('America/New_York')
                                    .format("hh:mm:ss a")
                                : "N/A"
                            }} EST</span>
                          </div>
                        </span>
                        <span v-if="data.ecn == 'TWD'">
                          <div>
                            <span class="maturity">Collection Type</span> :
                            <span class="">{{ data.collectionTypeDisplay }}</span>
                          </div>
                          <div>
                            <span class="maturity">Collecting Until</span> :
                            <span class="">{{
                              data.bidBy
                                ? moment
                                    .utc(data.bidBy)
                                    .tz('America/New_York')
                                    .format("hh:mm:ss a")
                                : "N/A"
                            }} EST</span>
                          </div>
                          <div v-if="data.collectionType == 'OPEN'">
                            <span class="maturity">Firm Until</span> :
                            <span class=""
                              >Bid time +{{
                                data.goodForTime
                                  ? data.goodForTime / 60 + "Mins"
                                  : "N/A"
                              }} EST</span
                            >
                          </div>
                          <div v-if="data.collectionType != 'OPEN'">
                            <span class="maturity">Firm Until</span> :
                            <span class="">{{
                              moment.utc(data.postAtTime)
                                .add(data.goodForTime, "seconds")
                                .tz('America/New_York')
                                .format("hh:mm:ss a")
                            }} EST</span>
                          </div>
                          <div v-if="data.collectionType != 'DEFINEDWOREVIEW' && data.collectionType != 'OPEN' ">
                            <span class="maturity">Review Period</span> :
                            <span class=""
                              >{{moment(data.postAtTime).diff(data.bidBy, "minutes")}} Mins 
                            </span>
                          </div>
                        </span>
                    </td>
                   
                     
                    </tr>
                  </tbody>
                </table>
                <!-- Pagination-->
                <b-pagination
                  class="mt-4"
                  :total-rows="totalRows"
                  v-model="currentPage"
                  :per-page="perPage"
                  @input="getBidwantedList(currentPage)"
                ></b-pagination>
                <div class="total-records">
                  <span>Total Records : {{ totalRows }}</span>
                </div>
              </div>
            </div>
            <SupportData
              v-bind:bidwanted="selectedBidWanted"
              v-if="supportDataModalOpen"
              @close="toggleSupportDataModal()"
            />
            <AutoBidderFailedLogs
              v-bind:bidwanted="selectedBidWanted"
              v-if="failedLogModalOpen"
              @close="toggleFailedLogModal()"
            />
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>
  <script>
import config from "@/config";
import authService from "@/authService";
import Datepicker from "vuejs-datepicker";
import SupportData from "././autobidlist/SupportDataModal";
import AutoBidderFailedLogs from "././AutoBidderFailedLogs";

export default {
  name: "imsCusipComponent",
  components: {
    Datepicker,
    SupportData,
    AutoBidderFailedLogs
  },
  data() {
    return {
      accessToken: null,
      loading: false,
      currentPage: 1,
      perPage: 10,
      searchValue: "",
      totalRows: 0,
      sortColumn: "id",
      sortOrder: "DESC",
      bidwantedList: [],
      createdDate: new Date(),
      showFilters: false,
      status: "",
      statusList: [
        "NEW",
        "BID_SENDING",
        "BID_SENT",
        "ORDER_RECEIVED",
        "ACCEPTED",
        "REJECTED",
        "SUCCESS",
        "HISTORY",
        "BID_CANCELLED",
        "TRADED_AWAY",
        "SUBJECT",
        "TRADE_CANCELLED",
        "EXPIRED",
        "DID_NOT_TRADE",
        "APPROVAL_PENDING",
        "PASS"
      ],
      ecn: "",
      isShowExpired: false,
      traderList: [],
      filterTrader: null,
      fromDate: "",
      toDate: "",
      supportDataModalOpen: false,
      selectedBidWanted: null,
      showFailedLogs : false,
      failedLogModalOpen : false


    };
  },
  methods: {
    toggleFailedLogModal(bid){
      if (bid) {
        this.selectedBidWanted = bid;
      }
      this.failedLogModalOpen = !this.failedLogModalOpen

    },
    toggleSupportDataModal(bid) {
      if (bid) {
        this.selectedBidWanted = bid;
      }
      // this.supportDataModalOpen = false;
      this.supportDataModalOpen = true;
      window.scrollTo(0, document.body.scrollHeight / 2);

    },
    getTraderList() {
      const auth = {
        headers: { "org-token": authService.getOrgToken() },
      };
      this.$http
        .get(
          config.baseUrlBidSide +
            "/user/list?page=1&size=1000&search=&status=ACTIVE&sortColumn=firstName&sortOrder=ASC&group=Drl-Trader",
          auth
        )
        .then((result) => {
          this.traderList = result.data.content;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    sort(column) {
      this.sortColumn = column;
      this.sortOrder =
        this.sortOrder == "ASC"
          ? (this.sortOrder = "DESC")
          : (this.sortOrder = "ASC");
      this.getBidwantedList();
    },
    search(){
        this.currentPage = 1;
        this.getBidwantedList();
    },
    clear() {
      const defaultValues = {
        searchValue: "",
        status: "",
        ecn: "",
        filterTrader: null,
        currentPage: 1,
        isShowExpired: false,
        fromDate : this.moment().format("MM-DD-YYYY"),
        toDate : this.moment().add(1,'days').format("MM-DD-YYYY")
      };
      Object.assign(this, defaultValues);
      this.getBidwantedList();
    },
    getBidwantedList() {
      this.loading = true;
      const auth = {
        headers: { "org-token": authService.getOrgToken() },
      };
      var fDate = this.fromDate
        ? this.moment(this.fromDate).utc().format("YYYY-MM-DD HH:mm:ss")
        : "";
      var tDate = this.toDate
        ? this.moment(this.toDate).utc().format("YYYY-MM-DD HH:mm:ss")
        : "";

      this.$http
        .get(
          config.baseUrlAutoBidder +
            "/autobidder/report-bids?page=" +
            this.currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&status=" +
            this.status +
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder +
            "&ecn=" +
            this.ecn +
            "&assignedBy=" +
            (this.filterTrader ? this.filterTrader.id : "") +
            "&executedFrom=" +
            fDate +
            "&executedTo=" +
            tDate+
            "&showFailedLog="+this.showFailedLogs,
          auth
        )
        .then((result) => {
          this.totalRows = result.data.pageInfo.totalElements;
          result.data.content.forEach((element) => {
            if (element.collectionType == "OPEN") {
              element.collectionTypeDisplay = "Open";
            }
            if (element.collectionType == "DEFINEDWREVIEW") {
              element.collectionTypeDisplay = "Defined With Review  ";
            }
            if (element.collectionType == "DEFINEDWOREVIEW") {
              element.collectionTypeDisplay = "Defined Without Review";
            }
          });
          this.bidwantedList = result.data.content;
          this.loading = false;
        })
        .catch(() => (this.loading = false));
    },
    exportData() {
        this.loading = true;
        const auth = {
          headers: { "org-token": authService.getOrgToken() },
        };
        const fDate = this.fromDate
          ? this.moment(this.fromDate).utc().format("YYYY-MM-DD HH:mm:ss")
          : "";
        const tDate = this.toDate
          ? this.moment(this.toDate).utc().format("YYYY-MM-DD HH:mm:ss")
          : "";
        const url = `${config.baseUrlAutoBidder}/autobidder/excel-report?search=${this.searchValue}&status=${this.status}&sortColumn=${this.sortColumn}&sortOrder=${this.sortOrder}&ecn=${this.ecn}&userId=${this.filterTrader ? this.filterTrader.id : ""}&executedFrom=${fDate}&executedTo=${tDate}&cognitoSub=${authService.getUser().cognitoSub}`;
        this.$alert("Export is in progress, download file from File Logs once completed","","success");            
        
        this.$http
          .get(url, auth)
          .then(() => {
            //window.open(response.data, "_blank");
          })
          .catch(() => {
            console.log("Error exporting data");
          })
          .finally(() => {
            this.loading = false;
          });
      }
  },
  mounted() {
    this.fromDate = this.moment().format("MM-DD-YYYY");
    this.toDate = this.moment().add(1,'days').format("MM-DD-YYYY");
    this.getBidwantedList();
    this.getTraderList();
  },
};
</script>
<style>
.ibtn {
  width: 30px;
  height: 30px;
}
</style>